
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { TaskTemplateTagModel } from './Entities.GormCrm.TaskTemplateTag';
import { TaskflowTemplateModel } from './Entities.GormCrm.TaskflowTemplate';
import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class TaskTemplateModel extends Model<TaskTemplateModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'title', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'defaultDeadline', type: 'number' },
		{ name: 'taskflowTemplateId', type: 'string' },
		{ name: 'step', type: 'number' },
		{ name: 'taskActions', type: 'TaskActionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'taskTemplateTags', type: 'TaskTemplateTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskTemplateTagModel }, properties: () => { return TaskTemplateTagModel.classProperties } },
		{ name: 'taskflowTemplate', type: 'TaskflowTemplateModel', isHidden: true, isObject: true, new: () => { return new TaskflowTemplateModel }, properties: () => { return TaskflowTemplateModel.classProperties } },
		{ name: 'type', type: 'TaskActionType' }
	];
	[key: string]: any;
	
	public id?: string;
	public title: string;
	public created?: Date;
	public deleted?: Date;
	public defaultDeadline?: number;
	public taskflowTemplateId?: string;
	public step: number;
	public taskActions: TaskActionModel[];
	public taskTemplateTags: TaskTemplateTagModel[];
	public taskflowTemplate?: TaskflowTemplateModel;
	public type: TaskActionType;
    
	constructor(){
		super();
		this.id = undefined;
		this.title = '';
		this.created = undefined;
		this.deleted = undefined;
		this.defaultDeadline = undefined;
		this.taskflowTemplateId = undefined;
		this.step = 0;
		this.taskActions = [];
		this.taskTemplateTags = [];
		this.taskflowTemplate = undefined;
		this.type = 0;
		
	}
	getProperties(){
		return TaskTemplateModel.classProperties;
	}
}

